<template>
	<el-row class="container">
		<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
			<h3 class="title">数据查询</h3>
			<el-form-item prop="account">
			  <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
			</el-form-item>
			<el-form-item prop="checkPass">
			  <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码" @keyup.enter.native="handleSubmit2"></el-input>
			</el-form-item>
			<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
			<el-form-item style="width:100%;">
			  <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
			  <!--<el-button @click.native.prevent="handleReset2">重置</el-button>--> 
			</el-form-item>
		</el-form>
	</el-row>
</template>

<script>
  import { saveData } from '../api/api';
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
		
      };
    },
	mounted() {
        this.getCookie();
    },
    methods: {
		handleReset2() {
			this.$refs.ruleForm2.resetFields();
		},
		setCookie(c_name, c_pwd, exdays) {
			var exdate = new Date(); //获取时间
			exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
			//字符串拼接cookie
			window.document.cookie = "zd_s_user" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
			window.document.cookie = "zd_s_pwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
		},
		//清除cookie
		clearCookie: function() {
			this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
		},
		//读取cookie
		getCookie: function() {
			if (document.cookie.length > 0) {
				var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
				for (var i = 0; i < arr.length; i++) {
					console.log(""+arr[i]);
					var arr2 = arr[i].split('='); //再次切割
					//判断查找相对应的值
					if (arr2[0] == 'zd_s_user') {
						console.log("set="+arr[i]);
						this.ruleForm2.account = arr2[1]; //保存到保存数据的地方
					} else if (arr2[0] == 'zd_s_pwd') {
						console.log("set="+arr[i]);
						this.ruleForm2.checkPass = arr2[1];
					}
				}
			}
		},
		handleSubmit2(ev) {
			var _this = this;
			if(_this.checked){
				//选择了
				_this.setCookie(_this.ruleForm2.account, _this.ruleForm2.checkPass, 7);
			}else {
			//清空Cookie
			_this.clearCookie();
			}
			this.$refs.ruleForm2.validate((valid) => {
				if (valid) {
					this.logining = true;
					let para = {
						username: this.ruleForm2.account, 
						password: this.ruleForm2.checkPass,
						actionurl:'login',				
					};
					saveData(para).then((res) => {
						this.logining = false;
						//console.log(res.data);
						if (res.data.code == 200) {
							sessionStorage.setItem('user', JSON.stringify(res.data.user));
							this.$router.push({ path: '/Index' });
						}else{
							this.$message({
								message: res.data.msg,
								type: 'error'
							});
						}
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
    }
  }

</script>

<style lang="scss" scoped>
	.container{
		margin: 0px;
		padding: 0px;
		//background: url(statis/img/53.jpg);
		height: 100%;
		width: 100%;
	}
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: Transparent;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: Transparent;
    border: 1px solid Transparent;
    box-shadow: 0 0 25px #f9f0ff;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
	
  }
</style>


// WEBPACK FOOTER //
// Login.vue?5fefdd17